import React from 'react';
import { getDisplayCompanyName } from '../utils/branding';

/**
 * Reusable Logo Component for consistent logo display across all pages
 */
const CompanyLogo = ({ appConfig, domainConfig, appName, style = {} }) => {
  // Helper function to check if URL is absolute (full URL)
  const isAbsoluteUrl = (url) => {
    if (!url) return false;
    return /^https?:\/\//.test(url);
  };

  // Priority 1: Logo from redirected application (appConfig) - if it's a full URL
  const appLogo =
    appConfig?.logo ||
    appConfig?.appLogo ||
    domainConfig?.companyLogo;
  // Priority 2: Logo from domainInfo (companyLogo - full URL)
  const domainLogo = domainConfig?.companyLogo;
  // Priority 3: Default logo
  const defaultLogo = "/icon.png";

  // Use appLogo only if it's a full URL, otherwise use domainLogo
  const logoToDisplay = 
    (appLogo && isAbsoluteUrl(appLogo) ? appLogo : null) ||
    domainLogo ||
    appLogo || // Fallback to appLogo even if relative path
    defaultLogo;

  const companyName = getDisplayCompanyName(
    domainConfig?.companyName || appName,
    "CRM"
  );

  const defaultStyle = {
    maxWidth: "200px",
    maxHeight: "80px",
    marginBottom: "16px",
  };

  return (
    <img
      src={logoToDisplay}
      alt={companyName}
      className="company-logo"
      style={{ ...defaultStyle, ...style }}
      onError={(e) => {
        // Fallback to default icon if image fails to load
        if (
          e.target.src !==
          window.location.origin + defaultLogo
        ) {
          e.target.src = defaultLogo;
        }
      }}
    />
  );
};

export default CompanyLogo;
